import {
  mediaQueries,
  typography,
  colors,
  size,
  Container as RawContainer,
  Row as RawRow,
  Col as RawCol,
  Button,
} from '@everlywell/leaves';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';

export const HeroWrapper = styled.div`
  position: relative;

  ${mediaQueries.forTabletHorizontalUp} {
    width: 100%;
  }
`;

export const HeroInner = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  width: 100%;
  position: relative;
`;

export const Content = styled.div`
  padding: 0 ${size.lg}px 36px;
  box-sizing: border-box;

  ${mediaQueries.forTabletVerticalUp} {
    padding: 0 ${size.xl4}px 36px;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    padding: 36px ${size.xl4}px;
    width: 50%;
  }
`;

export const HeroTop = styled.div<{ $backgroundColor?: string }>`
  background-color: ${(props) => props.$backgroundColor || 'transparent'};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 386px;

  ${mediaQueries.forTabletHorizontalUp} {
    justify-content: flex-end;
  }
`;

export const HeroBottom = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${size.xl2}px;

  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: ${size.xl4}px;
  }
`;

export const Section = styled.div`
  display: flex;
  align-items: center;
  background: linear-gradient(180deg, #1a3c3c 50%, #fff 50%);
  width: auto;
  border-radius: unset;
  position: relative;
  margin: 0;
  top: 60px;
  height: unset;

  ${mediaQueries.forTabletHorizontalUp} {
    height: 620px;
  }

  ${mediaQueries.forDesktopUp} {
    height: 750px;
  }
`;

export const Container = styled(RawContainer)`
  width: 100%;
  margin: 0;

  ${mediaQueries.forTabletHorizontalUp} {
    width: 50%;
    margin-left: 0;
  }

  ${mediaQueries.forDesktopUp} {
    margin-left: 0;
  }
`;

export const Row = styled(RawRow)`
  margin: 36px -12px;
  max-width: 530px;
`;

export const Col = styled(RawCol)`
  padding: 0;
`;

export const ImageWrapper = styled(RawCol)`
  position: relative;
  padding: 0;
  left: 5%;
  width: 90%;
  margin-top: -30%;
  margin-bottom: 36px;

  ${mediaQueries.forTabletVerticalUp} {
    left: 12.5%;
    width: 75%;
    margin-top: -15%;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    &.col {
      position: absolute;
      width: 50%;
      max-width: 720px;
      top: 25%;
      left: 50%;
      margin: unset;
    }
  }
`;

export const Image = styled(GatsbyImage)`
  height: 100%;
`;

export const Title = styled.h1`
  ${typography.overlineText};
  font-weight: ${typography.weight.book};
  color: #bfdce0;
  margin-bottom: 36px;
  margin-top: ${size.xl2}px;

  ${mediaQueries.forTabletHorizontalUp} {
    margin-top: 0;
  }
`;

export const Headline = styled.h2`
  ${typography.h1Text};
  margin-top: 0;
  color: #bfdce0;
  font-weight: ${typography.weight.regular};
  width: 100%;
  max-width: 36.25rem;

  ${mediaQueries.forTabletHorizontalUp} {
    line-height: ${size.xl4}px;
  }
`;

export const Description = styled.p`
  ${typography.bodyText};
  line-height: 1.8125rem;
  margin-bottom: 36px;
`;

export const CTA = styled(Button)`
  background-color: ${colors.teal4};
  border-color: ${colors.teal4};
  color: ${colors.white};
  padding: 11px 31px;
  text-decoration: none;
  font-size: 18px;
  font-weight: ${typography.weight.regular};
  line-height: ${size.lg}px;
  letter-spacing: 0.3px;

  ${mediaQueries.forTabletHorizontalUp} {
    padding: 17px 51px;
  }
`;
